import React, { useEffect } from 'react'
import ReactDOM from "react-dom";
import { combineClasses } from 'utils/utils';
import styles from "./Drawer.module.scss";
import { useBlockScroll } from 'hooks';

const withDrawerOpen = (WrappedComponent) => {
    return function ConditionalModal(props) {
        const { drawerOpen } = props;
        if (!drawerOpen) return null;
        return <WrappedComponent {...props} />;
    };
};

const Drawer = ({
    drawerOpen,
    onClose,
    heading,
    shadowClassName = "",
    wrapperClassName = "",
    bodyClassName = "",
    headerClassName = "",
    children,
    doNotClose = false,
    height = "auto",
    width = "45rem",
    background = "#fafbff",
    position = "right",
}) => {
    useBlockScroll(drawerOpen)

    if (!drawerOpen) return null;
    return ReactDOM.createPortal(
        <div
            className={combineClasses(styles.mainContainer, shadowClassName)}
            onMouseDown={(e) => {
                e.stopPropagation();
                !doNotClose && onClose(false);
            }}
        >
            <div
                onMouseDown={(e) => e.stopPropagation()}
                style={{
                    height: height,
                    backgroundColor: background || "#fafbff",
                    width: width,
                }}
                className={combineClasses(styles.drawerDiv,styles[position], wrapperClassName)}
            >
                {heading && typeof heading === "string" ? (
                    <div className={combineClasses(styles.drawerHeader, headerClassName)}>
                        <p>{heading}</p>
                    </div>
                ) : heading}
                <div className={combineClasses(styles.drawerBody, bodyClassName)}>{children}</div>
            </div>
        </div>,
        document.getElementById("root")
    );
}

export default withDrawerOpen(Drawer)